export default "__VITE_ASSET__DjXbhACF__"